import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FascicoloAnonimo } from '../../models/ricerca-anonima-dto';
import { Pagination } from 'src/app/common/models/pagination';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { ConsultazioneAnonimaFascicoloModalComponent } from '../consultazione-anonima-fascicolo-modal/consultazione-anonima-fascicolo-modal.component';

@Component({
  selector: 'app-consultazione-anonima-list-fascicoli',
  templateUrl: './consultazione-anonima-list-fascicoli.component.html',
  styleUrls: ['./consultazione-anonima-list-fascicoli.component.css']
})
export class ConsultazioneAnonimaListFascicoliComponent implements OnChanges {
  @Input() fascicoli: FascicoloAnonimo[];
  currentFascicoli: FascicoloAnonimo[];
  resetCurrentPage: boolean = false;
  currentPage: number = 0;
  itemsPerPage: number = 10;

  constructor(
    private dialogService: DialogService
  ){}
  
  ngOnChanges(changes: SimpleChanges): void {
      if(!!changes.fascicoli){
        this.resetCurrentPage = true;
        this.currentPage = 0;
        this.setCurrentFascicoli();
      }
    }
  
    onRefresh(event: Pagination) {
      this.currentPage = event.getCurrentPage();
      this.itemsPerPage = event.getItemsPerPage();
  
      this.setCurrentFascicoli();
      this.resetCurrentPage = false;
    }
  
    setCurrentFascicoli(){
      this.currentFascicoli = this.fascicoli.slice(this.currentPage*this.itemsPerPage, (this.currentPage+1)*this.itemsPerPage);
    }

  viewFascicoloModal(fascicolo: FascicoloAnonimo){
    console.log(fascicolo);
    const ref = this.dialogService.open(ConsultazioneAnonimaFascicoloModalComponent, {
      data: {
        style: {
          width: "75%",
          height: "75%"
        },
        title: "Fascicolo anonimizzato "+fascicolo.numeroRuolo+"/"+fascicolo.annoRuolo,
        fascicoloAnonimo: fascicolo
      },
    });
  }

  replaceNull (value) {
    return !!value && value != '' ? value : '-';
  }

}
